import { apiWrapper } from "@/services/api";
import store from "@/store";

export const putApproveReservation = async (apiParams, reservation) => {
  try {
      const response = await apiWrapper("PUT", `/demand-approve`, apiParams);
      console.log("putApproveReservation response.data :>> ", response.data);
      store.commit("demand/setReservation", reservation);
      return reservation
  } catch (err) {
    console.log('ERROR"" putApproveReservation():', err);
    throw err;
  }
};